<template>

    <a-layout id="app" style="min-width:1000px">
        <template v-if="layout_type == 'noAuthPath'">
            <!-- 登陆等公共页面 -->
            <router-view />
        </template>
        <template v-else>
             <Login :key="`${this.$store.state.routerKey}${this.$route.path}-${JSON.stringify(this.$route.query)}`"
            v-if="!this.$store.state.isLogin" />
            <a-layout-header class="header" style="height:42px;padding:0;"  v-if="this.$store.state.isLogin">
                <div class="logo">
                    <img src="@/assets/logo.png" />
                </div>
                <Breadcrumb :key="Math.random()"></Breadcrumb>
                <User :key="Math.random()"></User>
            </a-layout-header>
            <a-layout  v-if="this.$store.state.isLogin">
                <a-layout-sider width="200" >
                    <Menu :key="Math.random()"></Menu>
                </a-layout-sider>
                <a-layout style="padding: 0;">

                    <a-layout-content :style="{ backgroundColor: '#f7f8fa', padding: '0', margin: 0}">
                        <div class="routeView">
                            <a-config-provider :locale="locale">
                                <router-view
                                    :key="`${this.$store.state.routerKey}${this.$route.path}-${JSON.stringify(this.$route.query)}`">
                                </router-view>
                            </a-config-provider>
                        </div>
                    </a-layout-content>
                </a-layout>
            </a-layout>
        </template>
       
    </a-layout>
</template>

<script>
import Login from "./pages/home/login.vue";
import Menu from "./components/Menu.vue";
import User from "./components/User.vue";
import Breadcrumb from "./components/Breadcrumb.vue";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
export default {
    data() {
        return {
            locale: zhCN,
            layout_type:''
        };
    },
    methods:{
      
    },
    mounted(){
        
    },
    components: {
        Menu,
        Breadcrumb,
        Login,
        User
    },
    beforeUpdate(){
        //区分公共页面，文档中心页面，管理后台页面
        const noAuthPath = ["/aliweixincode"]; // 不需要鉴权的路径
        if(noAuthPath.includes(this.$route.path)){
            this.layout_type = 'noAuthPath';
        }
        else{
            this.layout_type = ''
        }
    }
};
</script>
<style>

</style>